/** Must match the header checked by lighthouse-backend activity tracking. */
export const IMPERSONATION_SESSION_HEADER = 'X-Impersonation-Session-Id'

export const IMPERSONATION_KEY = 'lh_impersonation'

/**
 * Distinct from the default `sb-<ref>-auth-token` key so GoTrue's
 * BroadcastChannel (named after the storage key) does not sync an
 * impersonation session into other product tabs.
 */
export const IMPERSONATION_AUTH_STORAGE_KEY = 'sb-lh-impersonation-auth-token'

/**
 * True while a staff impersonation handoff is in progress or an impersonation
 * session is stored for this tab. Used to keep support browsing out of
 * product analytics (LogRocket, last-active, etc.).
 */
export function isImpersonatingClient(): boolean {
    if (typeof window === 'undefined') return false
    const path = window.location.pathname.replace(/\/+$/, '') || '/'
    if (path === '/impersonate') return true
    try {
        return Boolean(sessionStorage.getItem(IMPERSONATION_KEY))
    } catch {
        return false
    }
}

/**
 * Headers to attach to authenticated product API calls while staff are
 * impersonating, so the backend can exclude those requests from
 * last_active_at / user_activity_sessions metrics.
 */
export function getImpersonationHeaders(): Record<string, string> {
    try {
        const raw = sessionStorage.getItem(IMPERSONATION_KEY)
        if (!raw) return {}
        const sessionId = (JSON.parse(raw) as { sessionId?: string })?.sessionId
        if (!sessionId) return {}
        return { [IMPERSONATION_SESSION_HEADER]: String(sessionId) }
    } catch {
        return {}
    }
}
